// STYLES
import './_blog-post.scss'

// LIBS
import React from 'react'
import {get, sortBy} from 'lodash/fp'
import {format, compareDesc} from 'date-fns'

// HELPERS
import * as util from '../../lib/util.js'
const defaultImageHeader = 'https://images.ctfassets.net/k428n7s2pxlu/255eIwS1B2kim6mcEwwUyU/edc660e718b50a9aed8561723b7a7dc2/blog-post-blog-seattle-tech-company-recruits-python-students-to-build-sdk-as-class-project.jpg'
let blogPostMetaDataList = require('../../data/code/blog-post-list-metadata.json')

blogPostMetaDataList = blogPostMetaDataList.sort((a, b) => compareDesc(new Date(a.node.createdAt),  new Date(b.node.createdAt)))

// COMPONENTS
import Disqus from '../../components/disqus'
import MetaData from '../../components/meta-data'
import AuthorMetaData from '../../components/author-metadata'

// INTERFACE
export const query = graphql`
  query BlogJsonQuery($slug: String!) {
    blogJson(slug: { eq: $slug}) {
      slug
      intro
      title
      content
      createdAt
      metaDescription
      imageCredit
      blogAuthor {
        fields {
          name
          slug
          twitter
          website
          biography
          image {
            fields {
              file {
                url
              }
            }
          }
        }
      }
      imageHeader {
        fields {
          file {
            url
          }
        }
      }
    }
  }
`;

export default ({data, location}) => {
  let { blogJson} = data
  let html = blogJson.content
  let imageHeader = get('imageHeader.fields.file.url', blogJson) || defaultImageHeader
  let authorSlug = '/' + (get('blogAuthor.fields.slug', blogJson) || 'blog/author/code-fellows')
  let authorName = get('blogAuthor.fields.name', blogJson) || 'Code Fellows'

  let currentBlogPostIndex = blogPostMetaDataList.reduce((r, n, i) => {
    if (blogJson.slug == n.node.slug) return i
    return r || 0
  }, 0)

  let nextBlogPost =  get('node', blogPostMetaDataList[currentBlogPostIndex - 1 ]) || {}
  let prevBlogPost =  get('node', blogPostMetaDataList[currentBlogPostIndex + 1]) || {}


  return (
    <div style={{paddingTop: '70px'}} className='LegacyPost'>
      <MetaData data={blogJson} >
      <script type='text/javascript' src='//platform-api.sharethis.com/js/sharethis.js#property=5b1f0c5cc05d470011577479&product=inline-share-buttons' async='async' />
      </MetaData>
      <div className='short_top' id='content'>
        <div style={{maxHeight: '400px', overflow: 'hidden' }} id="subheader" className="blog-subheader">
          <div className='FeaturedImageOverlay'>
            <img style={{width: '100%'}} alt='featured' src={imageHeader} />
            {util.renderIf(blogJson.imageCredit,
              <div className='image_credit'>
                <a href={blogJson.imageCredit}>Image Credit</a>
              </div>
            )}
          </div>
        </div>
      </div>
      <article itemScope itemType="http://schema.org/LiveBlogPosting">
          <div className='container'>
            <div className='row'>
              <div className="col-md-8 col-md-offset-2 blog_content">
                <p className="author_name">
                   <span  itemProp="author" itemScope itemType="http://schema.org/Person"> <link itemProp='sameAs' href={authorSlug}/>By&nbsp;<a itemProp='name' href={authorSlug}>{authorName}</a></span>
                   <span style={{ float: 'right' }} itemProp="datePublished" content={blogJson.createdAt}> {format(blogJson.createdAt, 'MMMM D, YYYY')} </span>
                </p>
                <h1 itemProp='headline'>{blogJson.title}</h1>
              </div>
            </div>
            <div className='row'>
              <div className="col-md-8 col-md-offset-2" style={{ marginBottom: '20px' }} >
                <div className="sharethis-inline-share-buttons"></div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-md-offset-2" style={{ marginBottom: '50px' }} >
                {util.renderIf(blogJson.intro,
                  <div itemProp='description' className="blog_content"> <div dangerouslySetInnerHTML={{ __html: blogJson.intro }} /> </div>
                )}
                <div itemProp='articleBody' className='blog_content' dangerouslySetInnerHTML={{ __html: html }} />
                  {/*<h3>About the Author</h3>*/}
                <div className='blog-post-nav' >
                  <main>
  {util.renderIf(nextBlogPost.slug, <a href={'/' + nextBlogPost.slug} alt={nextBlogPost.title} className='btn btn-default btn-primary btn-next'>Next Post</a>)}
  {util.renderIf(prevBlogPost.slug, <a href={'/' + prevBlogPost.slug} alt={prevBlogPost.title} className='btn btn-default btn-primary btn-prev'>Previous Post</a>)}
                  </main>
                </div>
    <div style={{paddingTop: '2em'}}>
      <hr style={{borderTop: '2px solid #e7e9ee'}}/>
      <h3 className='about-the-author'>About the Author</h3>
                <AuthorMetaData authorJson={blogJson.blogAuthor.fields} showAboutTheAuthor={true} />
    </div>
                <Disqus identifier={blogJson.slug} title={blogJson.title} />
              </div>
            </div>
          </div>
      </article>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/templates/blog-post/index.js